<template>
  <div>
    <b-card-actions
      :show-loading="saving || fetching"
      action-collapse
      action-refresh
      :title="$t('Lançamentos de Transferências')"
      @refresh="getTransfer"
    >
      <b-table
        ref="reconciliation-transfer-items-table"
        show-empty
        responsive
        striped
        class="bordered"
        :empty-text="getEmptyTableMessage($tc('RECONCILIATION_ITEM.NAME'), 'male')"
        :fields="fields"
        :items="reconciliationTransferItems"
      >
        <template #thead-top>
          <b-tr>
            <b-th
              variant="primary"
              colspan="7"
            >
              {{ $t('Transação Stripe') }}
            </b-th>
          </b-tr>
        </template>

        <template #cell(transferId)="row">
          <span :title="row.item.description">{{
            row.item.transferId
          }}</span>
        </template>

        <template #custom-foot>
          <tr>
            <th  />
            <th class="text-right">
              {{ stripeTotalValue | currency }}
            </th>
            <th class="text-right">
              {{ stripeTotalCommission | currency }}
            </th>
            <th class="text-right">
              {{ stripeTotal | currency }}
            </th>
          </tr>
        </template>
      </b-table>

    </b-card-actions>
  </div>
</template>

<script>
import { BTable, BTr, BTh } from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import { mapState, mapGetters } from 'vuex'
import { reconciliationDomains } from '@/mixins'

export default {
  components: {
    BTable,
    BTr,
    BTh,
    BCardActions,
  },

  mixins: [reconciliationDomains],

  props: {
    saving: {
      type: Boolean,
      default: false,
    },
    fetching: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState('pages/financial/reconciliation/stripe/maintain', [
      'reconciliationTransferItems',
      'summaryTransferFields',
      'sorting',
    ]),

    ...mapGetters('app', ['paymentMethodsOptions']),

    stripeTotalValue() {
      return this.summaryTransferFields?.stripeTotalValue?.value
    },
    stripeTotalCommission() {
      return this.summaryTransferFields?.stripeTotalCommission?.value
    },
    stripeTotal() {
      return this.summaryTransferFields?.stripeTotal?.value
    },

    fields() {
      return [
        {
          label: this.$t('Transferência'),
          key: 'transferId',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          label: this.$t('Valor'),
          key: 'amount',
          tdClass: 'text-right',
          formatter: value => this.$options.filters.currency(value),
          sortable: true,
        },
        {
          label: this.$t('Comissão'),
          key: 'fee',
          tdClass: 'text-right',
          formatter: value => this.$options.filters.currency(value),
          sortable: true,
        },
        {
          label: this.$t('Liquido'),
          key: 'net',
          tdClass: 'text-right',
          formatter: value => this.$options.filters.currency(value),
          sortable: true,
        }
      ]
    }
  },

  mounted() {
  },

  methods: {
    getTransfer() {
      this.$emit('get-data')
    },

    resetFiltersLocal() {
      this.getTransfer()
    },
  },
}
</script>

<style></style>
